import {commonConfig, momentFormat} from "@/config/common";
import {getStorage, StorageKey} from "@/tools/storage";
import {
  assembleDemandOptions,
  checkExtensionFieldVal,
  checkIsNeedReview,
  checkRespCorrect,
  checkReviewDiff,
  checkStaticFieldsVal,
  generateRandomPwd
} from "@/tools/utils";
import {meeting} from "@/server";
import {messageHdl} from "@/tools/messageHdlr";

export default {
  computed: {
    userId() {
      this.username = getStorage(StorageKey.username);
      return this.$store.state.userId || getStorage(StorageKey.userId)
    },
    randomPwd() {
      return {
        join: generateRandomPwd(),
        control: generateRandomPwd(),
      }
    },
    dftSubject() {
      return this.username && !this.sysRequiredFields.subject
        ? (this.username + "的会议")
        : ("请填写" + this.sysFormTitles.subject)
    },
    // 是否进行中会议
    isInMeeting() {
      return this.mid && this.cMDoc && this.cMDoc.status === commonConfig.meetingStatus.MEETING && true || false;
    },
    // 是否为组织会议
    isOrganizeMeetings() {
      return this.cMDoc && this.cMDoc.ccFromMid && true || false
    },
    participantNum() {
      if (this.sysRequiredFields.numberOfPeople) {
        return Number(this.dataProxy.numberOfPeople)
      }
      const participantPlus = this.dataSource.insideParticipant.length
        + this.dataSource.outsideParticipant.length;
      const inputNum = Number(this.dataProxy.numberOfPeople) || 1;
      if (participantPlus > inputNum) {
        return participantPlus;
      }
      return inputNum
    },
    // 选取option
    dftDemandOptions() {
      return assembleDemandOptions({
        reserveDoc: {
          room: this.dataSource.chosenRoom || {},
          customerGrade: this.dataProxy.customerGrade || 0,
          insideParticipant: this.dataSource.insideParticipant,
        },
        serviceSetting: this.serviceSetting,
      })
    },
    roomSupportInfo() {
      const {chosenRoom} = this.dataSource;
      if (chosenRoom.roomId) {
        const {roomSupport} = this.$store.state.sysConfig;
        if (chosenRoom.supportTime || roomSupport) {
          return {
            ...roomSupport,
            ...chosenRoom.supportTime,
            prompt: roomSupport && roomSupport.prompt || commonConfig.roomSupportPrompt
          }
        }
      }
      return {}
    },
    roomSupportTime() {
      const info = this.roomSupportInfo;
      // console.log(info);
      if (info.start || info.end) {
        const date = moment().format(momentFormat.date);
        const hour = {
          start: info.start && (new Date(`${date} ${info.start}`)).valueOf() || 0,
          end: info.end && (new Date(`${date} ${info.end}`)).valueOf() || 0,
        };
        if (hour.start < hour.end) return hour;
      }
    },
    reviewProcessOptions() {
      const sysReviewProcess = this.$store.state.sysConfig.reviewProcess || [];
      const reviewProcess = (this.dataSource.chosenRoom || {}).reviewProcess || [];
      return sysReviewProcess.filter(e => reviewProcess.includes(e.value))
    },
    reserveInterval() {
      const {roomId, reserveInterval} = this.dataSource.chosenRoom || {};
      if (!roomId) return 0;
      if (reserveInterval) return reserveInterval;
      const {roomReserveInterval} = this.$store.state.sysConfig;
      return roomReserveInterval || 0;
    },
  },
  watch: {
    reviewProcessOptions: function (val) {
      // console.log("reviewProcessOptions:", val);
      if (this.dataProxy.reviewProcessCode && val.some(e => e.value === this.dataProxy.reviewProcessCode)) return;
      if (val.length === 1) {
        this.dataProxy.reviewProcessCode = val[0].value
      } else {
        this.dataProxy.reviewProcessCode = ""
      }
    },
  },
  methods: {
    checkFormFields() {
      const failKey = checkStaticFieldsVal(this.sysRequiredFields, {
        ...this.dataSource,
        subject: this.dataProxy.subject,
        numberOfPeople: this.participantNum,
      });
      if (failKey) {
        return `请填写${this.sysFormTitles[failKey]}`;
      }

      const formattedExtFields = {};
      const extFieldEle = this.extensionFieldSettings.find(ele => {
        const {val, fail} = checkExtensionFieldVal(ele, this.extensionFields);
        if (fail) {
          return true;
        }
        if (ele.valType === 'int' && val) {
          formattedExtFields[ele.key] = parseInt(val);
        } else {
          formattedExtFields[ele.key] = val;
        }
        return false;
      });
      if (extFieldEle) return `请填写${extFieldEle.label}`;
      this.dataSource.formattedExtFields = formattedExtFields;
    },
    checkMeetingRoom() {
      const {startTime, chosenRoom} = this.dataSource;
      const roomTitle = this.sysFormTitles.meetingRoom;
      if (!chosenRoom.roomId) {
        if (this.hasTeleconference && this.isCustomTlc) {
          return `请选择${roomTitle}`;
        }
        if (!this.hasTeleconference || (!this.isOrganizeMeetings && this.tlcOnlyRelated)) {
          return this.tlcOnlyRelated ? `请选择${roomTitle}` : `请选择${roomTitle} 或 预约视频会议`
        }
      }
      // 预约间隔
      if (this.reserveInterval) {
        const {startTime: oldStartTime} = this.cMDoc || {};
        const startTimeVal = startTime.valueOf();
        // 编辑时若没有修改时间则不校验预约间隔
        if (!this.mid || oldStartTime !== startTimeVal) {
          const curTime = new Date().valueOf();
          if (((startTimeVal - curTime) / 1000 / 60) < this.reserveInterval) {
            return `【${chosenRoom.name}】会议需预留会务支持时间，请至少提前${this.reserveInterval}分钟预约`;
          }
        }
      }
      if (chosenRoom.reviewMode === commonConfig.reviewModes.OUTER.value && !this.dataProxy) {
        return "请选择审批流程"
      }
    },
    getSubmitTips(destData) {
      const tips = [];
      const roomTitle = this.sysFormTitles.meetingRoom;
      const {startTime, chosenRoom} = this.dataSource;
      // 提示需审核
      if (chosenRoom.reviewMode && checkIsNeedReview(destData, this.cMDoc)) {
        const less = checkReviewDiff(startTime, this.$store.state.sysConfig.preReviewTime, chosenRoom);
        if (less) {
          return {errMsg: less}
        }
        tips.push(`所选${roomTitle}【${chosenRoom.roomNum}】预约需审核，是否确认提交？`)
      }
      // 提示不在会务支持时间内
      if (this.roomSupportTime) {
        const {start, end} = this.roomSupportTime;
        const cTime = (new Date()).valueOf();
        if (cTime < start || (end && cTime > end)) {
          const info = this.roomSupportInfo;
          tips.push(`会务支持时间：${info.start || '-'} ~ ${info.end || '-'}。${info.prompt}，是否确认提交？`)
        }
      }
      if (!tips.length) {
        tips.push(this.mid ? "是否确认修改会议预约信息？" : "是否确认提交会议预约信息？")
      }
      // console.log(tips)
      return {tips}
    },

    submitMDoc(destData) {
      // console.log(destData);
      // return;
      window.UIBlock && UIBlock.block(this, '努力提交中...');  // admin
      window.UILoader && UILoader.load("努力提交中...");  // front

      if (this.mid) {
        this.editMDoc(destData)
      } else {
        this.newMDoc(destData)
      }
    },
    // 新建会议
    newMDoc(data) {
      meeting.reserveMeeting(this, {meeting: data}).then(({newMeeting: resp = {}}) => {
        if (checkRespCorrect.call(this, resp, "保存失败")) {
          this.handleResp(resp)
        }
      }).catch(err => {
        messageHdl.call(this, {msg: err.message});
      })
    },
    // 修改会议
    editMDoc(data) {
      meeting.editMeeting(this, {
        mid: this.mid,
        meeting: data,
        isSubUpdate: !this.showPeriodic,
      }).then(({editMeeting: resp = {}}) => {
        if (checkRespCorrect.call(this, resp, "保存失败")) {
          this.handleResp(resp)
        }
      }).catch(err => {
        messageHdl.call(this, {msg: err.message});
      })
    },
  }
}
